<div>
  <button role="button" id="menu-btn-toggle"  [attr.aria-label]=" 'NXI_NAVIGATION.MOBILESIDENAV' | translate  " [attr.aria-expanded]="isMenuOpen"    class="fw-SideNav_Menu" (click)="toggleSideNavDisplay()"
  style="border: none; background-color: transparent">
    <span class="fas fa-bars"></span>
  </button>
</div>
